import { createI18n } from 'vue-i18n'
import en from '@/core/locales/en.json'
import ru from '@/core/locales/ru.json'
import zh from '@/core/locales/zh.json'
import hi from '@/core/locales/hi.json'

const STORAGE_KEY = 'codeboard_lang'
const SUPPORTED_LOCALES = ['en', 'ru', 'zh', 'hi'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const supportedLanguages = [
  { code: 'en' as const, name: 'English' },
  { code: 'ru' as const, name: 'Русский' },
  { code: 'zh' as const, name: '中文' },
  { code: 'hi' as const, name: 'हिन्दी' },
]

export function detectLocale(): SupportedLocale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && SUPPORTED_LOCALES.includes(saved as SupportedLocale)) {
      return saved as SupportedLocale
    }
  } catch {
    // localStorage unavailable
  }

  const browserLang = navigator.language.split('-')[0]
  if (SUPPORTED_LOCALES.includes(browserLang as SupportedLocale)) {
    return browserLang as SupportedLocale
  }

  return 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, ru, zh, hi },
})

